import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import SignIn from '@/components/SignIn'
import SignUp from '@/components/SignUp'
import PasswordRecovery from '@/components/PasswordRecovery'
import ChangePassword from '@/components/ChangePassword'
import Dashboard from '@/components/Dashboard'
import PanelControl from '@/components/PanelControl'
import NewShipmentFlowFromHome from '@/components/NewShipmentFlowFromHome'
import NewShipmentFlowFromDashboard from '@/components/NewShipmentFlowFromDashboard'
import ServiceProviderSelector from '@/components/ServiceProviderSelector'
import ShipmentsList from '@/components/ShipmentsList'
import ShipmentDetails from '@/components/ShipmentDetails'
import EditShipmentDestination from '@/components/editShipment/EditShipmentDestination'
import EditShipmentOrigin from '@/components/editShipment/EditShipmentOrigin'
import EditShipmentParcels from '@/components/editShipment/EditShipmentParcels'
import EditShipmentDescription from '@/components/editShipment/EditShipmentDescription'
import EditShipmentInsurance from '@/components/editShipment/EditShipmentInsurance'
import EditShipmentServiceProvider from '@/components/editShipment/EditShipmentServiceProvider'
import PaymentDetails from '@/components/PaymentDetails'
import PaymentsDetails from '@/components/PaymentsDetails'
import PaymentResult from '@/components/PaymentResult'
import Contact from '@/components/Contact'
import Services from '@/components/Services'
import AboutUs from '@/components/AboutUs'
import TermsAndConditions from '@/components/TermsAndConditions'
import PrivacyAdvice from '@/components/PrivacyAdvice'
import ThankPage from '@/components/ThankPage'
import FrequentQuestions from '@/components/FrequentQuestions'
import Configuration from '@/components/Configuration'
import CashBarcode from '@/components/CashBarcode'
import Integrations from '@/components/Integrations'
import Addresses from '@/components/Addresses'
import Payments from '@/components/Payments'
import Etatistics from  '@/components/Etatistics'
import GeneralReport from '@/components/GeneralReport'
import OverweightReport from '@/components/OverweightReport'
import Overweight from '@/components/Overweight'
import NewPrepaid from '@/components/NewPrepaid'
import ListPrepaid from '@/components/ListPrepaid'
import Users from '@/components/Users'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { ownFooter: true }
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/password-recovery/:token',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/password-recovery',
      name: 'PasswordRecovery',
      component: PasswordRecovery
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: PanelControl,
      redirect: '/dashboard',
      // Usado por App.vue para no duplicar el footer global: PanelControl.vue
      // ya pone el suyo propio dentro de .sw-content (con el margin-left del
      // sidebar), así que el de App.vue se omite en cualquier ruta anidada
      // aquí. $route.matched conserva este registro (y su meta) aunque la
      // ruta activa sea una hija con path absoluto, no "/dashboard/...".
      meta: { dashboard: true },
      children: [
        {
          path: '/',
          component: Etatistics
        },
        {
          path: '/shipments',
          component: ShipmentsList
        },
        {
          path: '/shipments/:id',
          component: ShipmentDetails
        },
        {
          path: '/integrations',
          component: Integrations
        },
        {
          path: '/payments',
          component: Payments
        },
        {
          path: '/addresses',
          component: Addresses
        },
        {
          path: '/general_report',
          component: GeneralReport
        },
        {
          path: '/overweight_report',
          component: OverweightReport
        },
        {
          path: '/overweight',
          component: Overweight
        },
        {
          path: '/dashboard/shipment/new',
          name: 'NewShipmentFlowFromDashboard',
          component: NewShipmentFlowFromDashboard
        },
        {
          path: '/prepaids',
          name: 'ListPrepaid',
          component: ListPrepaid
        },
        {
          path: '/prepaid/new',
          name: 'NewPrepaid',
          component: NewPrepaid
        },
        {
          path: '/users',
          name: 'Users',
          component: Users
        },
        {
          path: '/configuracion',
          component: Configuration
        },

      ]
    },
    {
      path: '/payments/result/:result',
      component: PaymentResult,
      meta: { ownFooter: true }
    },
    {
      path: '/payments/:id',
      component: PaymentDetails
    },
    {
      path: '/payment/shipments/many',
      component: PaymentsDetails
    },
    {
      path: '/shipments/:id/edit/destination',
      component: EditShipmentDestination
    },
    {
      path: '/shipments/:id/edit/origin',
      component: EditShipmentOrigin
    },
    {
      path: '/shipments/:id/edit/parcels',
      component: EditShipmentParcels
    },
    {
      path: '/shipments/:id/edit/description',
      component: EditShipmentDescription
    },
    {
      path: '/shipments/:id/edit/insurance',
      component: EditShipmentInsurance
    },
    {
      path: '/shipments/:id/edit/service-provider',
      component: EditShipmentServiceProvider
    },
    {
      path: '/service-providers',
      name: 'ServiceProviderSelector',
      component: ServiceProviderSelector
    },
    {
      path: '/shipment/new',
      name: 'NewShipmentFlowFromHome',
      component: NewShipmentFlowFromHome,
      meta: { ownFooter: true }
    },
    {
      path: '/contactanos',
      component: Contact,
      meta: { ownFooter: true }
    },
    {
      path: '/servicios',
      component: Services,
      meta: { ownFooter: true }
    },
    {
      path: '/quienes-somos',
      component: AboutUs,
      meta: { ownFooter: true }
    },
    {
      path: '/terminos-de-servicio',
      component: TermsAndConditions,
      meta: { ownFooter: true }
    },
    {
      path: '/politicas-de-privacidad',
      component: PrivacyAdvice,
      meta: { ownFooter: true }
    },
    {
      path: '/thank-page',
      component: ThankPage
    },
    {
      path: '/preguntas-frecuentes',
      component: FrequentQuestions,
      meta: { ownFooter: true }
    },
    {
      path: '/shipping/cash_barcode',
      component: CashBarcode
    }

  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// Sin este guard, entrar a cualquier ruta de /dashboard sin sesión dejaba
// que cada componente armara sus peticiones con
// localStorage.getItem('ew-user-id') === null tal cual — de ahí las
// peticiones a /api/v1/shipments/all/null y /api/v1/marketplace/shipments/null
// que el backend rechaza con 500 (visto en producción 2026-09-22). Se
// revisa toda la cadena de rutas coincidentes (to.matched), no solo la
// hoja, porque las rutas hijas de /dashboard tienen paths absolutos
// ("/shipments", no "/dashboard/shipments") pero heredan el meta del
// padre a través de esa cadena.
router.beforeEach((to, from, next) => {
  const requiresSession = to.matched.some(record => record.meta.dashboard)
  const hasSession = !!localStorage.getItem('ew-user-id')

  if (requiresSession && !hasSession) {
    next({ path: '/signin', query: { redirect: to.fullPath } })
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js